import React, { useState } from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import classNames from "classnames";
import { RichText } from "@sitecore-jss/sitecore-jss-react";
import { generateReactKey } from "../../../utils/reactKey";
import ToolSectionType from "./ToolSectionType";
import Icon from "../../../elements/icon";
import InfoModal from "../../../components/InfoModal";
import BodyText from "../../../elements/body-text";
import LoadingSpinner from "../../../elements/loading-spinner";
import ServerError from "../../../sections/server-error";

const ToolSectionTabs = ({ match, defaultLabel, options = [], isSpecialFormat, lang, serverResponseErrorMsg, isLoading }) => {
  const currentRouteTabIndex = match.params.param_2 || defaultLabel ? options.findIndex(option => option.path?.toLowerCase() === (match.params.param_2 || defaultLabel).toLowerCase()) : 0,
    [selectedOptionIndex, setSelectedOptionIndex] = useState(currentRouteTabIndex),
    [activeItems = [], setActiveItems] = useState(options[currentRouteTabIndex]?.items || []),
    [showInfoModalIndex, setShowInfoModalIndex] = useState(-1);

  return (
    <div className="tool-section-tabs">
      <div className="option-tabs">
        {options.map(({ label, path, items, onTabClicked }, index) => {
          const pathArr = [match.params.lang, match.params.sitecoreRoute.replace(/^\//, ""), "l", match.params.param_1, "p", path];
          return (
            path && (
              <div
                key={generateReactKey()}
                className="option-tab"
                onClick={e => {
                  onTabClicked(e, path);
                  setSelectedOptionIndex(index);
                  setActiveItems(items);
                }}
              >
                <Link
                  to={`/${pathArr.join("/")}`}
                  onClick={e => {
                    e.preventDefault();
                  }}
                >
                  <div
                    className={classNames("value", {
                      active: index === selectedOptionIndex
                    })}
                  >
                    {label}
                  </div>
                </Link>
              </div>
            )
          );
        })}
      </div>
      {isLoading && <LoadingSpinner />}
      {activeItems &&
        activeItems.map(({ label, infoIcon, infoModal, description, ...tools }, index) => (
          <div className="tool-section" key={generateReactKey()}>
            {label && (
              <div className="section-heading">
                <BodyText html={`<p>${label}</p>`} />
                {infoIcon && (
                  <>
                    <Icon
                      {...{
                        icon: {
                          alt:
                            '<svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24"><path d="M0 0h24v24H0V0z" fill="none" /><path d="M11 7h2v2h-2zm0 4h2v6h-2zm1-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z" /></svg>'
                        },
                        onClick: () => {
                          setShowInfoModalIndex(index);
                        }
                      }}
                    />
                    {infoModal && (
                      <InfoModal
                        {...{
                          ...infoModal,
                          showModal: showInfoModalIndex === index,
                          setShowModal: () => {
                            setShowInfoModalIndex(null);
                          }
                        }}
                      />
                    )}
                  </>
                )}
              </div>
            )}
            <ToolSectionType {...tools} lang={lang} isSpecialFormat={isSpecialFormat} />
            <RichText tag="p" className="info" field={{ value: description }} />
          </div>
        ))}
      {serverResponseErrorMsg && <span className="warning-message">{serverResponseErrorMsg}</span>}
    </div>
  );
};

ToolSectionTabs.propTypes = {
  match: PropTypes.object,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      infoIcon: PropTypes.bool,
      description: PropTypes.string
    })
  )
};

export default ToolSectionTabs;
